import React, { useState, useEffect } from "react";

import { Router } from "@reach/router";

import {
  Layout,
  Menu,
  Avatar,
  Dropdown,
  message,
  PageHeader,
  Breadcrumb,
  Tooltip,
  Select,
  Space,
  Spin,
} from "antd";

import {
  HomeOutlined,
  ShopOutlined,
  CopyOutlined,
  AppstoreOutlined,
  IdcardOutlined,
  FundProjectionScreenOutlined,
  FileExcelOutlined,
  BarChartOutlined,
  CustomerServiceOutlined,
  ExportOutlined,
  DesktopOutlined,
  MenuOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";
import Cookies from "js-cookie";

import Overview from "./Overview";
import Brand from "./Brand";
import News from "./News";
import Product from "./Product";
import Gbook from "./Gbook";
import Rank from "./Rank";
import Visitor from "./Visitor";
import Report from "./Report";

import LogoLong from "../../images/logo_long.png";
import LogoShort from "../../images/logo_short.png";

import styles from "./Website.module.less";

const { Sider } = Layout;
const { SubMenu } = Menu;
const { Option } = Select;

function Website({ navigate, location, user }) {
  const brandId = Cookies.get("bid");

  const [loading, setLoading] = useState(true);
  const [brand, setBrand] = useState(null);
  const [brandList, setBrandList] = useState([]);

  const [collapsed, setCollapsed] = useState(false);
  const [page, setPage] = useState({ open: [], selected: [] });
  const [position, setPosition] = useState({
    name: null,
    url: null,
    sub: {},
  });

  const menu = [
    {
      name: "系统中控",
      url: "website/overview",
      icon: HomeOutlined,
      sub: [],
    },
    {
      name: "店铺设置",
      url: "website/brand",
      icon: ShopOutlined,
      sub: [],
    },
    {
      name: "文章管理",
      url: "website/news",
      icon: CopyOutlined,
      sub: [],
    },
    {
      name: "产品管理",
      url: "website/product",
      icon: AppstoreOutlined,
      sub: [],
    },
    {
      name: "留言管理",
      url: "website/gbook",
      icon: IdcardOutlined,
      sub: [],
    },
    {
      name: "搜索排名",
      url: "website/rank",
      icon: FundProjectionScreenOutlined,
      sub: [],
    },
    {
      name: "流量统计",
      url: "website/visitor",
      icon: BarChartOutlined,
      sub: [],
    },
    {
      name: "报表下载",
      url: "website/report",
      icon: FileExcelOutlined,
      sub: [],
    },
  ];

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  const onLogout = async () => {
    try {
      let para = queryString.stringify({});
      let parsed = await Http.get(`logout`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        window.location = "https://sso.chinaqyz.com/";
      } else {
        await message.warn("退出失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onReturn = async () => {
    window.location = "https://sso.chinaqyz.com/";
  };

  const userDrop = (
    <Menu>
      <Menu.Item>
        <Space onClick={onReturn}>
          <DesktopOutlined />
          <span>返回后台</span>
        </Space>
      </Menu.Item>
      <Menu.Item>
        <Space onClick={() => navigate(`/welcome`)}>
          <MenuOutlined />
          <span>品牌管理</span>
        </Space>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <Space onClick={onLogout}>
          <ExportOutlined />
          <span>退出登录</span>
        </Space>
      </Menu.Item>
    </Menu>
  );

  const onMenuLocal = () => {
    menu.forEach((value) => {
      if (location.pathname.includes(value.url)) {
        setPage({ open: [], selected: [value.url] });
        setPosition({
          ...position,
          name: value.name,
          url: `/${value.url}`,
          sub: {},
        });
      } else {
        value.sub.forEach((val) => {
          if (location.pathname.includes(val.url)) {
            setPage({ open: [value.url], selected: [val.url] });
            setPosition({
              name: value.name,
              url: `/${value.url}`,
              sub: { name: val.name, url: val.url },
            });
          }
        });
      }
    });
  };

  const onBrandChange = (bid) => {
    Cookies.set("bid", bid);
    window.location.reload();
  };

  const getBrandList = async () => {
    let para = queryString.stringify({});
    let parsed = await Http.get(`brand/list`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setBrandList(parsed.result);
      parsed.result.forEach((value) => {
        if (brandId === String(value.id)) {
          setBrand(value);
        }
      });
    }
  };

  const onLoading = async () => {
    setLoading(true);
    try {
      await getBrandList();
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onMenuLocal();
  }, [location.pathname]);

  useEffect(() => {
    if (user) {
      onLoading();
    }
  }, [user]);

  return (
    <div className={styles.Website}>
      <Layout style={{ height: "100vh" }}>
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
          <div className={styles.logo}>
            <img src={collapsed ? LogoShort : LogoLong} />
          </div>
          <Menu
            theme="dark"
            mode="inline"
            openKeys={page.open}
            selectedKeys={page.selected}
            onOpenChange={(e) => {
              setPage({ ...page, open: e });
            }}
          >
            {menu.map((value) =>
              value.sub.length > 0 ? (
                <SubMenu
                  key={value.url}
                  icon={<value.icon />}
                  title={value.name}
                >
                  {value.sub.map((val) => (
                    <Menu.Item
                      key={val.url}
                      onClick={() => {
                        navigate(val.url === "/" ? `/` : `/${val.url}`);
                        setPage({ ...page, selected: [val.url] });
                      }}
                    >
                      {val.name}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={value.url}
                  icon={<value.icon />}
                  onClick={() => {
                    navigate(value.url === "/" ? `/` : `/${value.url}`);
                    setPage({ ...page, selected: [value.url] });
                  }}
                >
                  {value.name}
                </Menu.Item>
              )
            )}
          </Menu>
        </Sider>
        <Layout>
          <div className={styles.header}>
            <div className={styles.headerAttach}>
              <div className={styles.attachLeft}>
                <PageHeader title={position.name} subTitle={brand?.name} />
              </div>
              <div className={styles.attachRight}>
                {loading ? (
                  <div className={styles.col}>
                    <Spin />
                  </div>
                ) : (
                  <div className={styles.col}>
                    <Select
                      style={{ width: 240 }}
                      defaultValue={brandId}
                      onChange={onBrandChange}
                      loading={loading}
                    >
                      {brandList.map((value) => (
                        <Option key={value.id} value={String(value.id)}>
                          {value.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                )}
                <div className={styles.col}>
                  <Tooltip title="在线客服">
                    <a
                      target="_blank"
                      href="https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97d37457cf7317cfe64fe2e4606dbbee773e4c56db55232512781cd28c30c0e9346b72685972c96ba7960d830a8cbf97b2"
                    >
                      <CustomerServiceOutlined style={{ fontSize: "20px" }} />
                    </a>
                  </Tooltip>
                </div>
                <Dropdown overlay={userDrop} placement="bottomRight" arrow>
                  <div className={styles.welcome}>
                    <Avatar
                      size={32}
                      style={{ backgroundColor: "#fde3cf" }}
                      src={
                        user?.avatar
                          ? user.avatar
                          : "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                      }
                    />
                    <span>{user?.username ? user.username : "-----"}</span>
                    <CaretDownOutlined />
                  </div>
                </Dropdown>
              </div>
            </div>
            <div className={styles.headerPosition}>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <HomeOutlined />
                </Breadcrumb.Item>
                <Breadcrumb.Item href="/welcome">秒排宝</Breadcrumb.Item>
                <Breadcrumb.Item href={position.url}>
                  {position.name}
                </Breadcrumb.Item>
                {position.sub ? (
                  <Breadcrumb.Item href={position.sub.url}>
                    {position.sub.name}
                  </Breadcrumb.Item>
                ) : null}
              </Breadcrumb>
            </div>
          </div>
          <div className={styles.content}>
            <Router>
              <Overview path="overview/*" user={user} brand={brand} />
              <Brand path="brand/*" brand={brand} />
              <News path="news/*" brand={brand} />
              <Product path="product/*" brand={brand} />
              <Gbook path="gbook/*" brand={brand} />
              <Rank path="rank/*" brand={brand} />
              <Visitor path="visitor/*" brand={brand} />
              <Report path="report/*" brand={brand} />
            </Router>
          </div>
        </Layout>
      </Layout>
    </div>
  );
}

export default Website;
